import { Injectable } from '@angular/core';
import {
  QuestionnaireClinicalHBIResult, QuestionnaireClinicalPRISMResult,
  QuestionnaireClinicalSCCAIResult,
  QuestionnaireEORTCResult,
  QuestionnaireEQ5D5LResult,
  QuestionnaireHADSResult,
  QuestionnaireHBIResult,
  QuestionnaireIBDDiskResult, QuestionnaireIBDQResult,
  QuestionnaireIPAQSFResult,
  QuestionnaireMIAHCDResult,
  QuestionnaireMIAHUCResult,
  QuestionnaireMMAS8Result,
  QuestionnairePatientSCCAIResult,
  QuestionnairePHQ9Result, QuestionnairePRISMResult,
  QuestionnairePSQIResult,
  QuestionnaireSIBDQResult,
  QuestionnaireTSQMResult,
  QuestionnaireWPAIResult,
  QuestionnaireLARSResult,
} from '../model/questionnaires/questionnaire-results';
import {BackendApi, localhost} from '../config/backend-api';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ChatMessage} from "../model/chat-message/ChatMessage";
import { Announcement } from '../model/announcement/Announcement';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  doctorID = '';
  ssn = '';

  constructor(private httpClient: HttpClient) {
    this.doctorID = JSON.parse(localStorage.getItem('doctor')).doctorID;
    this.ssn = JSON.parse(localStorage.getItem('user')).ssn;
  }

  getQuestionnairesClinicalSCCAI(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireClinicalSCCAIResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesClinicalHBI(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireClinicalHBIResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesClinicalPRISM(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireClinicalPRISMResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesEORTC(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireEORTCResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesEQ5D5L(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireEQ5D5LResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesHADS(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireHADSResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesHBI(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireHBIResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesIBDDisk(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireIBDDiskResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesIPAQSF(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireIPAQSFResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesMIAHCD(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireMIAHCDResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesMIAHUC(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireMIAHUCResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesMMAS8(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireMMAS8Result[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesPatientSCCAI(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnairePatientSCCAIResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesPHQ9(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnairePHQ9Result[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesPRISM(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnairePRISMResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesPSQI(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnairePSQIResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesSIBDQ(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireSIBDQResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesIBDQ(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireIBDQResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesLARS(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireLARSResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getQuestionnairesTSQM(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireTSQMResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }
  getQuestionnairesWPAI(type: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<QuestionnaireWPAIResult[]>(localhost + BackendApi.GET_QUESTIONNAIRES_PATIENT + type + '/' + doctor.doctorID + '/' + patientSSN, {observe: 'response'});
  }

  getUpdatedQuestionnaires() {
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    return this.httpClient.get<string[]>(localhost + BackendApi.GET_UPDATED_QUESTIONNAIRES + patientSSN);
  }

  // Restituisce l'elenco dei questionari compilabili dal paziente (id)
  getQuestionnairesTypeList(id) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    return this.httpClient.get<string[]>(localhost + BackendApi.GET_QUESTIONNAIRES_TYPE_LIST + id);
  }

  // Restituisce un valore booleano che esprime se il paziente oggi ha già compilato un questionario di quel tipo.
  hasQuestionnaireAlreadyCompletedToday(ssn, type: string) {
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    return this.httpClient.get<boolean>(localhost + BackendApi.HAS_QUESTIONNAIRE_ALREADY_COMPLETED_TODAY + patientSSN + '/' + type);
  }

  helloDoctor() {
    return this.httpClient.post(localhost + 'private/patient/hello/', 'hello', {responseType: 'text', observe: 'response'});
  }

  sendMessage(textSend: string) {
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const patient = JSON.parse(localStorage.getItem('user'));
    const mess = new ChatMessage(doctor.email, patient.email, textSend);
    return this.httpClient.post(localhost + 'private/chat', mess, {responseType: 'text', observe: 'response'});
  }

  getChatMessages(email) {
    const patient = JSON.parse(localStorage.getItem('user'));
    // const doctor = JSON.parse(localStorage.getItem('doctor'));
    return this.httpClient.get<ChatMessage[]>(localhost + 'private/chat/' + patient.email);
  }

  sendFile(file: any) {
    const formData = new FormData();
    formData.append('multiFile', file);
    const doctor = JSON.parse(localStorage.getItem('doctor'));
    const options = { params : new HttpParams().set('Content-Type', 'multipart/form-data')}

    /*let options = new HttpParams().set('Content-Type', 'multipart/form-data'); // create params object
    options = options.append('responseType', 'text'); // add a new param, creating a new object
    options = options.append('observe', 'response')*/
    return this.httpClient.post(localhost + 'private/chat/'+ doctor.email +'/uploadFile', formData, options);//{params: options});
  }

  getFile(patientEmail: string, id: string){
      return this.httpClient.get(localhost + 'private/chat/' + patientEmail + '/' + id, {responseType: 'blob'});
  }

  getAnnouncements() {
    return this.httpClient.get<Announcement[]>(localhost + 'private/get-announcements');
  }

  
  getLastAnnouncement() {
    return this.httpClient.get<Announcement>(localhost + 'private/get-last-announcement');
  }
}
